<mat-spinner mode="indeterminate"></mat-spinner>
Authenticating...
